"use client";

import { useEffect, useMemo } from "react";

export function SpeculationRules({
  prefetchPathsOnHover = [],
  prerenderPathsOnHover = [],
}: {
  prefetchPathsOnHover?: string[];
  prerenderPathsOnHover?: string[];
}): null {
  const speculationRules = useMemo(
    () =>
      JSON.stringify({
        prefetch: [
          {
            urls: prefetchPathsOnHover,
            eagerness: "moderate",
          },
        ],
        prerender: [
          {
            urls: prerenderPathsOnHover,
            eagerness: "moderate",
          },
        ],
      }),
    [prefetchPathsOnHover, prerenderPathsOnHover]
  );

  useEffect(() => {
    const script = document.createElement("script");
    script.id = "speculation-rules";
    script.type = "speculationrules";
    script.textContent = speculationRules;

    document.head.appendChild(script);

    return (): void => {
      script.remove();
    };
  }, [speculationRules]);

  return null;
}
